import { useUnit } from 'effector-react'
import {
  Divider,
  Form,
  InputNumber,
  Modal,
  Typography,
  Descriptions,
  Flex,
  Button,
} from 'antd'
import { updateAdditionalInvestorsFx } from './model'
import { Strategy } from 'src/pages/copytrade/strategies/list/types'

type Props = {
  isOpen: boolean
  onCancel: () => void
  data: Strategy
}

type ValueForm = {
  numAdditionalInvestors: number
}

export const AddInvestorsModal = ({ isOpen, onCancel, data }: Props) => {
  const { Item } = Descriptions
  const { Text } = Typography
  const [form] = Form.useForm()
  const { id, investors, numAdditionalInvestors } = data

  const valueAddInvestors =
    Form.useWatch('numAdditionalInvestors', form) ?? numAdditionalInvestors
  const loadingButton = useUnit(updateAdditionalInvestorsFx.pending)

  const handleSubmit = async ({ numAdditionalInvestors }: ValueForm) => {
    try {
      await updateAdditionalInvestorsFx({
        url: `/strategy/${id}`,
        body: { numAdditionalInvestors },
        query: {
          populate: JSON.stringify([
            'Strategy.account',
            'Strategy.strategyPerformances',
            'Strategy.achievements',
            'Strategy.strategySubscriptions',
          ]),
        },
      })
      handleCancel()
    } catch (error) {
      console.error(error)
    }
  }

  const handleCancel = () => {
    form.resetFields()
    onCancel()
  }

  return (
    <Modal
      title={<div style={{ fontSize: 20 }}>Set Displayed Investors</div>}
      open={isOpen}
      centered
      wrapClassName="ant_modal"
      width={550}
      maskClosable={false}
      destroyOnHidden
      onCancel={handleCancel}
      footer={null}
    >
      <Divider />
      <Descriptions
        column={1}
        colon={false}
        style={{ marginBottom: 16 }}
        styles={{
          label: {
            width: '50%',
            fontSize: 18,
          },
          content: { fontSize: 18 },
        }}
      >
        <Item label="Real Investors">{investors}</Item>
        <Item label="Displayed Investors">{investors + valueAddInvestors}</Item>
      </Descriptions>
      <Form
        form={form}
        layout="horizontal"
        labelCol={{ span: 12 }}
        wrapperCol={{ span: 12 }}
        labelAlign="left"
        onFinish={handleSubmit}
        initialValues={{ numAdditionalInvestors }}
      >
        <Form.Item
          label={
            <Text style={{ fontSize: 18 }} strong>
              Added Investors
            </Text>
          }
          tooltip="Set the value to 0 to display only the real number of investors."
          name="numAdditionalInvestors"
          rules={[
            {
              type: 'number',
              min: 0,
              max: 9999,
              message: 'Value must be between 0 and 9999.',
            },
          ]}
        >
          <InputNumber />
        </Form.Item>
        <Flex gap={8} justify="flex-end">
          <Button onClick={handleCancel}>Cancel</Button>
          <Button
            color="blue"
            variant="solid"
            htmlType="submit"
            loading={loadingButton}
          >
            Save
          </Button>
        </Flex>
      </Form>
    </Modal>
  )
}
